import { Regions } from '@xometry/ui';
import { getRegionHost } from 'config/regions/utils';
import { ENV_APP_HOST_CN } from 'constants/env';
import { ObjectType } from 'interfaces/shared';
import { routes } from 'routes';
import { TypeRouteId } from 'routes/api';

interface GetObjectLinkParams {
  dealId: TypeRouteId;
  objectId?: TypeRouteId;
  parentId?: TypeRouteId;
  type: string;
}

export const getDealObjectLink = ({ dealId, type, objectId, parentId }: GetObjectLinkParams) => {
  switch (type as ObjectType) {
    case ObjectType.OC:
      return routes.orderConfirmationPath(dealId);

    case ObjectType.D:
      return routes.dealPath(dealId);

    case ObjectType.Batch:
      return routes.dealFrameworkAgreementPath(dealId);
  }

  if (objectId) {
    if (objectId && parentId) {
      switch (type as ObjectType) {
        case ObjectType.RfqOffer:
          return routes.rfqOfferPath(dealId, parentId, objectId);

        case ObjectType.JO:
          return routes.jobOfferPath(dealId, parentId, objectId);
      }
    }

    switch (type as ObjectType) {
      case ObjectType.E:
        return routes.enquiryEditPath(dealId, objectId);

      case ObjectType.Payment:
        return routes.paymentPath(dealId, objectId);

      case ObjectType.II:
        return routes.editDealIncomingInvoicePath(dealId, objectId);

      case ObjectType.PZ:
        return routes.payoutPath(dealId, objectId);

      case ObjectType.PO:
        return routes.editProviderOrderPath(dealId, objectId);

      case ObjectType.CL:
        return routes.editDealClaimPath(dealId, objectId);

      case ObjectType.CreditNote:
        return routes.creditNotePath(dealId, objectId);

      case ObjectType.SH:
        return routes.editShippingPath(dealId, objectId);

      case ObjectType.J:
        return routes.jobPath(dealId, objectId);

      case ObjectType.OI:
        return routes.editOutcomingInvoicePath(dealId, objectId);

      case ObjectType.QC:
        return routes.editDealQualityControlPath(dealId, objectId);

      case ObjectType.RFQ:
        return routes.rfqEditPath(dealId, objectId);

      case ObjectType.HsCodeDataset:
        return routes.hsCodesPartPath(dealId, objectId);

      case ObjectType.Part:
        return routes.dealPartPath(dealId, objectId);

      case ObjectType.SU:
        return routes.editStoragePath(dealId, objectId);

      default:
        break;
    }
  }
};

interface GetForeignObjectLinkParams extends GetObjectLinkParams {
  region: Regions;
}

export const getForeignObjectLink = (params: GetForeignObjectLinkParams) => {
  const regionHost = getRegionHost(params.region);
  const link = getDealObjectLink(params);

  if (!link) return;

  return link.replace(routes.rootPath(), regionHost + '/');
};

export const getForeignObjectLinkCn = (params: GetObjectLinkParams) => {
  const link = getDealObjectLink(params);

  if (!link) return;

  return link.replace(routes.rootPath(), ENV_APP_HOST_CN + '/');
};
